import React, { useEffect, useRef } from 'react';
import useBodyScrollLock from '../../../../hooks/useBodyScrollLock';

/**
 * Міні-модалка підтвердження видалення (очікувана позиція поставки тощо).
 */
const IncomingDeleteItemConfirmModal = ({
  open,
  title,
  highlight,
  description,
  onCancel,
  onConfirm,
  submitting,
}) => {
  const panelRef = useRef(null);
  const cancelRef = useRef(null);
  useBodyScrollLock(open);
  useEffect(() => {
    if (!open) return;
    const previousFocus = document.activeElement;
    cancelRef.current?.focus();
    return () => {
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [open]);
  useEffect(() => {
    if (!open) return;
    const onKey = e => {
      if (e.key === 'Escape' && !submitting) onCancel();
      if (e.key === 'Tab') {
        const buttons = panelRef.current?.querySelectorAll('button:not([disabled])') || [];
        const first = buttons[0],
          last = buttons[buttons.length - 1];
        if (!first) {
          e.preventDefault();
          panelRef.current?.focus();
        } else if (
          e.shiftKey &&
          (document.activeElement === first || !panelRef.current?.contains(document.activeElement))
        ) {
          e.preventDefault();
          last.focus();
        } else if (
          !e.shiftKey &&
          (document.activeElement === last || !panelRef.current?.contains(document.activeElement))
        ) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onCancel, submitting]);

  if (!open) return null;

  return (
    <div
      className='incoming-delete-item-modal-backdrop'
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
      onClick={() => !submitting && onCancel()}
      role='presentation'
    >
      <div
        ref={panelRef}
        tabIndex={-1}
        className='incoming-delete-item-modal-panel shadow'
        style={{
          background: '#fff',
          borderRadius: '12px',
          maxWidth: '400px',
          width: '100%',
          padding: '1.25rem',
        }}
        onClick={e => e.stopPropagation()}
        role='dialog'
        aria-modal='true'
        aria-labelledby='incoming-delete-item-title'
        aria-describedby='incoming-delete-item-description'
      >
        <h5 id='incoming-delete-item-title' className='font-weight-bold mb-2'>
          {title || 'Видалити позицію?'}
        </h5>
        <p id='incoming-delete-item-description' className='text-muted small mb-3 mb-md-4'>
          {description || (
            <>
              Позицію
              {highlight ? (
                <>
                  {' '}
                  <span className='text-break font-weight-bold text-dark'>{highlight}</span>
                </>
              ) : null}{' '}
              буде видалено з цього надходження
            </>
          )}
        </p>
        <div className='d-flex justify-content-end flex-wrap' style={{ gap: '0.5rem' }}>
          <button
            ref={cancelRef}
            type='button'
            className='btn btn-outline-secondary btn-sm'
            onClick={onCancel}
            disabled={submitting}
          >
            Скасувати
          </button>
          <button
            type='button'
            className='btn btn-danger btn-sm'
            onClick={onConfirm}
            disabled={submitting}
          >
            {submitting ? 'Видалення…' : 'Видалити'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncomingDeleteItemConfirmModal;
